import type { DeliveryMethod } from "@dransay/api/models";
import { useMemo } from "react";

interface SelectedDeliveryMethodOptions {
	deliveryMethodUuid?: string | null;
	deliveryMethods: DeliveryMethod[];
}

export function useSelectedDeliveryMethod({
	deliveryMethodUuid,
	deliveryMethods,
}: SelectedDeliveryMethodOptions) {
	return useMemo(() => {
		if (!deliveryMethodUuid || !deliveryMethods?.length) {
			return undefined;
		}

		return deliveryMethods.find((method) => method.uuid === deliveryMethodUuid);
	}, [deliveryMethodUuid, deliveryMethods]);
}
